import { useRef, useState, useEffect } from 'preact/hooks'

import Icon from '@/components/snippets/icon/icon'
import { Logo } from '@/components/snippets/logo/logo'

import { AthosSuggestProvider } from '../fetchers/suggest'
import { SearchInput } from './SearchInput'
import { QuickSearchDropdown } from './QuickSearchDropdown'

function QuickSearch() {
  const searchInputRef = useRef()
  const [inputValue, setInputValue] = useState()
  const [query, setQuery] = useState()
  const [correctedQuery, setCorrectedQuery] = useState(false)
  const formRef = useRef()
  const [redirect, setRedirect] = useState()

  const handleFocusInput = () => {
    setTimeout(() => {
      searchInputRef.current.focus()
    }, 0)
  }

  const handleUpdateValue = (event) => {
    setRedirect(false)
    setInputValue(event.target.value)
  }

  const handleClearValue = () => {
    setInputValue('')
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setQuery(inputValue)
    }, 400)
    return () => {
      clearTimeout(timeout)
    }
  }, [inputValue])

  useEffect(() => {
    if (redirect && window.redirectTimeout) {
      clearTimeout(window.redirectTimeout)
      window.redirectTimeout = null

      window.location.href = redirect
    }
  }, [redirect])

  useEffect(() => {
    return () => {
      if (window.redirectTimeout) {
        clearTimeout(window.redirectTimeout)
        window.redirectTimeout = null
      }
    }
  }, [])

  const handleSubmit = (event) => {
    if (redirect) {
      event.preventDefault()
      window.location.href = redirect
      return
    }
    if (correctedQuery) {
      event.preventDefault()
      window.location.href = `/search?query=${correctedQuery}&oq=${query}`
      return
    }

    if (query && !redirect) {
      event.preventDefault()

      const redirectTimeout = setTimeout(() => {
        window.location.href = `/search?query=${query}`
      }, 2000)

      window.redirectTimeout = redirectTimeout
    }
  }

  return (
    <x-modal className="group">
      <button
        data-modal-role="open"
        className="items-center hidden h-10 gap-2 px-4 border rounded-full w-72 border-primary-blue xl:flex"
        onClick={handleFocusInput}
      >
        <Icon id="search-simple" className="w-4 h-4 text-primary-blue" />
        <span className="text-xs font-medium text-neutrals-secondary-grey">Search our range of products</span>
      </button>
      <button data-modal-role="open" className="btn btn-md btn-icon btn-inline xl:hidden" onClick={handleFocusInput}>
        <Icon id="search-simple" className="w-5 h-5" />
      </button>
      <div class="pointer-events-none fixed inset-0 -z-20 bg-black/60 opacity-0 group-data-visible:opacity-100"></div>
      <div
        className="
        pointer-events-none
        absolute -inset-x-px top-0 z-40 flex max-h-[80vh]
        flex-col overflow-hidden opacity-0 transition-opacity group-data-visible:pointer-events-auto
        group-data-visible:opacity-100
      "
      >
        <div className="flex flex-col overflow-hidden rounded-lg bg-primary-grey">
          <div className="flex items-center justify-between p-2 border-b h-14 border-neutrals-light-grey md:h-16 md:px-8">
            <Logo variant="dark" className="hidden md:flex" />
            <form
              ref={formRef}
              action="/search"
              method="get"
              className="flex justify-center w-full"
              onSubmit={handleSubmit}
            >
              <SearchInput
                ref={searchInputRef}
                value={inputValue}
                onInput={handleUpdateValue}
                onClear={handleClearValue}
              />
            </form>

            <button className="btn btn-md btn-inline btn-text-black md-max:btn-icon" data-modal-role="close">
              <span className="hidden whitespace-nowrap md:block">Close</span>
              <Icon id="close" />
            </button>
          </div>
          <QuickSearchDropdown query={query} inputValue={inputValue} correctedQuery={correctedQuery} setCorrectedQuery={setCorrectedQuery} setRedirect={setRedirect} redirect={redirect} />
        </div>
      </div>
    </x-modal>
  )
}

export function WrappedQuickSearch() {
  return (
    <AthosSuggestProvider resultsPerPage={4} runOnMount={false}>
      <QuickSearch />
    </AthosSuggestProvider>
  )
}
